import viewerBgImg from '@assets/images/dsahboard_bg.png';
import dashboardCircle from '@assets/icons/dashboard-circle.png';
import { Button, Tooltip } from 'antd';
import MetricsCard from '@features/viewer/components/MetricsCard';
import * as XLSX from 'xlsx';
import {
  getLeaderShipDashboard_Manager,
  getLeaderShipTableManagerData,
} from '../../redux/slice';
import { useDispatch, useSelector } from 'react-redux';
import backlogIcon from '@assets/icons/backlog.svg';
import ironBarIcon from '@assets/icons/iron_bar.svg';
import valueChainIcon from '@assets/icons/value_chain.svg';
import checkIcon from '@assets/icons/check.svg';
import garbageIcon from '@assets/icons/garbage.svg';
import coinsIcon from '@assets/icons/coins.svg';
import { getLastFinancialYear } from '@utils/helpers';
import { useCallback, useEffect, useState } from 'react';
import WastageProjectInfo from './WastageProjectInfo';
import {
  getFinancialYears,
  getProjectListManagerDashboard,
  getProjectListWithoutQuarterlyManagerDashboard,
  getQuarterList,
} from '@features/viewer/redux/slice';
import { debounce } from 'lodash';
import ManagerDashboardFilterSelectors from './ManagerDashboardFilterSelectors';
import AdvanceFilter from './AdvanceFilter';
import warningIcon from '@assets/icons/warning.svg';
import recycleBinIcon from '@assets/icons/recycle_bin.svg';
import activeArrowIcon from '@assets/icons/active_arrow_icon.svg';
import LocalStorage from '@utils/localStorage';

const FINANCIAL_YEAR = getLastFinancialYear();

const LeaderShipDashboard = () => {
  const user_details = LocalStorage.getItem('bbs_user');

  const dispatch = useDispatch();
  const { leaderShipDashboard, leaderShipManagerTableData, loading } =
    useSelector((state) => state.projectList);

  const {
    quarterListData,
    quarterListLoading,
    financialYearsData,
    financialYearsLoading,
    projectListDataManagerDashboard,
    projectListLoadingManagerDashboard,
    projectListDataWithoutQuarterlyManagerDashboard,
    projectListLoadingWithoutQuarterlyManagerDashboard,
  } = useSelector((state) => state.viewer);
  const [hovered, setHovered] = useState(null);

  const [selectedProjectsCode, setSelectedProjectsCode] = useState([]);
  const [selectedProjectsName, setSelectedProjectsName] = useState([]);
  const [
    selectedProjectsCodeWithoutQuarterly,
    setSelectedProjectsCodeWithoutQuarterly,
  ] = useState([]);
  const [loadProjectNames, setLoadProjectNames] = useState([]);

  const getTransformedFinancialQuarters = () => {
    const financialYears = selectedFinancialYear?.length
      ? selectedFinancialYear
      : [FINANCIAL_YEAR.year];
    const quarters = selectedQuarters?.length
      ? selectedQuarters
      : [FINANCIAL_YEAR.quarter];
    const fyMap = financialYears
      .filter((v) => v !== 'all')
      .map((fy) => ({
        financial_year: fy,
        quarters: [],
      }));

    quarters
      .filter((v) => v !== 'all')
      .forEach((qtr) => {
        const fyKey = qtr.split(' Q')[0];
        const fyEntry = fyMap.find((entry) =>
          entry.financial_year.startsWith(fyKey),
        );

        if (fyEntry) {
          fyEntry.quarters.push(qtr);
        }
      });

    const finalQuarters = fyMap.map((entry) => {
      if (entry.quarters.length === 0) {
        const selectedYear = entry.financial_year.slice(2, 4);
        const nextYear = entry.financial_year.slice(5, 7);

        return {
          ...entry,
          quarters: [
            `FY${selectedYear}-${nextYear} Q1(1-Apr-FY${selectedYear} to 30-Jun-FY${selectedYear})`,
            `FY${selectedYear}-${nextYear} Q2(1-Jul-FY${selectedYear} to 30-Sep-FY${selectedYear})`,
            `FY${selectedYear}-${nextYear} Q3(1-Oct-FY${selectedYear} to 31-Dec-FY${selectedYear})`,
            `FY${selectedYear}-${nextYear} Q4(1-Jan-FY${nextYear} to 31-Mar-FY${nextYear})`,
          ],
        };
      } else {
        return entry;
      }
    });
    return finalQuarters;
  };

  const [selectedFinancialYear, setSelectedFinancialYear] = useState([]);
  const [selectedQuarters, setSelectedQuarters] = useState([]);
  const [isInitialDataFetch, setIsInitialDataFetch] = useState(true);

  const handleApplyFilter = () => {
    const payload = {};

    if (selectedFinancialYear.filter((v) => v !== 'all').length) {
      payload.filter_array = JSON.stringify(getTransformedFinancialQuarters());
    }

    if (!selectedProjectsName.length) {
      // for project code with quarterly submission
      if (selectedProjectsCode.filter((v) => v !== 'all').length) {
        payload.project_code = [...new Set([...selectedProjectsCode])]
          .filter((v) => v !== 'all')
          .join(', ');
      }
      // for project code without quarterly submission
      if (
        selectedProjectsCodeWithoutQuarterly.filter((v) => v !== 'all').length
      ) {
        payload.project_code_no_quarterly = [
          ...new Set([...selectedProjectsCodeWithoutQuarterly]),
        ]
          .filter((v) => v !== 'all')
          .join(', ');
      }
    } else {
      if (selectedProjectsName.filter((v) => v !== 'all').length) {
        payload.project_code = [...new Set([...selectedProjectsName])]
          .filter((v) => v !== 'all')
          .join(', ');
      }
    }

    if (!selectedFinancialYear.length || !selectedQuarters.length) {
      payload.filter_array = JSON.stringify(getTransformedFinancialQuarters());
    }

    if (user_details?.user?.id) {
      payload.manager_id = user_details?.user?.id;
    }

    dispatch(getLeaderShipDashboard_Manager(payload));
    dispatch(getLeaderShipTableManagerData(payload));
    setIsInitialDataFetch(false);
  };

  const getAllInitialData = useCallback(() => {
    dispatch(getFinancialYears()).then(
      (res) => setSelectedFinancialYear([]),
      setSelectedQuarters([]),
    );
    const filter_array = JSON.stringify([
      {
        financial_year: FINANCIAL_YEAR.year,
        quarters: [FINANCIAL_YEAR.quarter],
      },
    ]);

    const payload = {
      filter_array,
    };
    if (user_details?.user?.id) {
      payload.manager_id = user_details?.user?.id;
    }

    dispatch(getProjectListManagerDashboard(payload)).then((res) => {
      setSelectedProjectsName([]);
      setSelectedProjectsCode([]);
    });
    dispatch(
      getProjectListWithoutQuarterlyManagerDashboard(payload),
    ).then((res) => {
      setSelectedProjectsName([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
    });

    dispatch(getLeaderShipDashboard_Manager(payload));
    dispatch(getLeaderShipTableManagerData(payload));
    setIsInitialDataFetch(true);
  }, [dispatch]);

  useEffect(() => {
    getAllInitialData();
  }, [getAllInitialData]);

  useEffect(() => {
    if (selectedFinancialYear.length) {
      dispatch(
        getQuarterList({
          financialYear: selectedFinancialYear
            .filter((v) => v !== 'all')
            .map((y) => {
              const selectedYear = y.slice(2, 4);
              const nextYear = y.slice(5, 7);

              return `${selectedYear}-${nextYear}`;
            })
            .join(','),
        }),
      );
    }
  }, [selectedFinancialYear, dispatch]);

  // ...... on financial year and quarter change fetching all list apis
  useEffect(() => {
    if (
      selectedFinancialYear.filter((v) => v !== 'all').length &&
      selectedQuarters.filter((v) => v !== 'all').length
    ) {
      const payload = {
        filter_array: JSON.stringify(getTransformedFinancialQuarters()),
        manager_id: user_details?.user?.id,
      };
      dispatch(getProjectListManagerDashboard(payload));
      dispatch(getProjectListWithoutQuarterlyManagerDashboard(payload));
      setSelectedProjectsCode([]);
      setSelectedProjectsCodeWithoutQuarterly([]);
      setSelectedProjectsName([]);
    }
  }, [selectedQuarters, dispatch]);

  // ...... on project code change fetching all list apis
  useEffect(() => {
    if (
      selectedProjectsCode.filter((v) => v !== 'all').length ||
      selectedProjectsCodeWithoutQuarterly.filter((v) => v !== 'all').length
    ) {
      setLoadProjectNames([
        ...projectListDataManagerDashboard.filter((p) =>
          selectedProjectsCode.includes(p.project_code),
        ),
        ...projectListDataWithoutQuarterlyManagerDashboard.filter((p) =>
          selectedProjectsCodeWithoutQuarterly.includes(p.project_code),
        ),
      ]);
      setSelectedProjectsName([]);
    }
  }, [
    selectedProjectsCode,
    projectListDataManagerDashboard,
    selectedProjectsCodeWithoutQuarterly,
    projectListDataWithoutQuarterlyManagerDashboard,
  ]);

  const COUNTS = [
    {
      counts: leaderShipDashboard?.total_projects || 0,
      countsSubLabel: 'Total Projects',
      label: 'in bbs optimization tool',
      countColor: '#1C4E9D',
      icon: backlogIcon,
      bigText: true,
      bgColor: '#b1cffe',
      hasOuterLayer: true,
      outerLayerBg: '#FFFFFF',
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#ffffff',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
    {
      counts: Number(
        leaderShipDashboard?.total_quantity_processed || 0,
      ).toFixed(2),
      label: 'With/without bbs Optimization tool',
      subLabel: '(in MT)',
      countColor: '#9747FF',
      countsSubLabel: 'Total quantity processed',
      icon: ironBarIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
    {
      counts: `${Number(leaderShipDashboard?.optimised_wastage || 0).toFixed(
        2,
      )} %`,
      label: 'With/without bbs Optimization tool',
      subLabel: '( % )',
      countColor: '#12B76A',
      icon: valueChainIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      countsSubLabel: 'Total wastage',
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[84px] right-1 -top-1 w-20',
      onHoverContent: null,
    },

    {
      counts: leaderShipDashboard?.total_bbs_created || 0,
      label: 'BBS Optimization usage',
      countsSubLabel: 'Projects with',
      countColor: '#FFFFFF',
      icon: checkIcon,
      bigText: true,
      bgColor: '#003B97',
      hasOuterLayer: true,
      outerLayerBg: '#99B1D5',
      labelColor: '#FFFFFF',
      countsSubLabelColor: '#ffffff7f',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      hoverIcon: activeArrowIcon,
      onHoverContent: [
        {
          counts: leaderShipDashboard?.total_projects_with_bbs || 0,
          label: '(quantity, wastage)',
          countsSubLabel: 'Projects submitted complete quarterly input',
          countColor: '#61C911',
          icon: recycleBinIcon,
          bigText: false,
          bgColor: '#FFFFFF',
          hasOuterLayer: false,
          labelColor: '#1C4E9D',
          countsSubLabelColor: '#1C4E9DB2',
          iconClasses: 'h-16 -right-2.5 top-0 w-16',
        },
        {
          counts: leaderShipDashboard?.total_projects_without_bbs || 0,
          countsSubLabel: 'Projects not submitted complete quarterly input',
          label: '(quantity, wastage)',
          countColor: '#B64439',
          icon: warningIcon,
          bigText: false,
          bgColor: '#FFFFFF',
          hasOuterLayer: false,
          labelColor: '#1C4E9D',
          countsSubLabelColor: '#1C4E9DB2',
          iconClasses: 'h-16 -right-2 top-0 w-16',
        },
      ],
    },
    {
      counts: Number(leaderShipDashboard?.total_savings || 0).toFixed(1),
      label: 'SAVINGS WRT BUDGETED WASTAGE',
      countsSubLabel: 'Total in Rs Lakhs',
      countColor: '#DC6701',
      icon: coinsIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3 -top-3 w-28',
      onHoverContent: null,
    },
    {
      counts: `${Number(
        leaderShipDashboard?.savings_wrt_budgeted_wastage || 0,
      ).toFixed(2)} %`,
      countsSubLabel: 'Percentage',
      label: 'SAVINGS WRT BUDGETED WASTAGE',
      countColor: '#FF8316',
      icon: garbageIcon,
      bigText: false,
      bgColor: '#FFFFFF',
      hasOuterLayer: false,
      labelColor: '#1C4E9D',
      countsSubLabelColor: '#1C4E9DB2',
      iconClasses: 'h-[105px] -right-3.5 -top-4 w-28',
      onHoverContent: null,
    },
  ];

  const debouncedSearch = useCallback(
    debounce((query, results) => {
      dispatch(results({ search: query }));
    }, 500),
    [],
  );

  const handleSearch = (val, results) => {
    debouncedSearch(val, results);
  };

  const handleChange = (val, setVals, data) => {
    const allSelected = val.includes('all');
    const isSelectingAll = val.at(-1) === 'all';
    if (val.length === 0) {
      setVals([]);
      return;
    }
    if (isSelectingAll) {
      setVals(['all', ...data]);
    } else if (allSelected && val.length - 1 < data.length) {
      setVals(val.filter((v) => v !== 'all'));
    } else {
      setVals(val);
    }
  };

  const getTransformedProjectsData = (data) => {
    return data.map((item) => {
      return {
        'Project Code': item.project_code || null,
        'Total Projects': item.project_count || null,
        'Quantity Processed - Quarterly': item.tonnage_quarterly,
        'Quantity Processed With BBS': item.tonnage_with_bbs,
        'Quantity Processed Without BBS': item.tonnage_without_bbs,
        'Total Wastage': item.total_wastage,
        'A1. Wastage': item.wastage_with_system,
        'A2. Wastage': item.wastage_with_actual,
        'B. Wastage': item.wastage_without_bbs,
        'Tool Adoption': item.adoption,
        // 'Actual Wastage': item.actual_wastage,
        // 'Optimal Wastage': item.optimal_wastage,
        'Budgeted Wastage': item.budgeted_wastage,
        'Savings/Overruns Wastage (in %)': item.savings_per,
        'Savings/Overruns Wastage (In Ton)': item.savings_in_ton,
        'Savings/Overruns Wastage (In Lakh)': item.savings_in_lakh,
      };
    });
  };

  const handleDownloadExcelSheet = () => {
    if (
      !leaderShipManagerTableData ||
      leaderShipManagerTableData?.project_list?.length === 0
    ) {
      alert('No data available to download.');
      return;
    }
    const worksheet = XLSX.utils.json_to_sheet(
      getTransformedProjectsData(leaderShipManagerTableData?.project_list),
    );
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(workbook, worksheet, 'Wastage Information');
    XLSX.writeFile(workbook, `Wastage Information.xlsx`);
  };

  return (
    <div className="flex overflow-hidden relative z-20 gap-1 w-full min-h-screen bg-white">
      <img
        src={viewerBgImg}
        alt="viewer bg img"
        className=" absolute top-0 left-0 w-full h-[250px] -z-10"
      />

      <div className="w-full md:w-[70%] lg:w-[78%] relative flex flex-col mt-6 lg:mt-8 animate-moveFromTop">
        <Button
          disabled={!leaderShipManagerTableData?.project_list?.length}
          onClick={handleDownloadExcelSheet}
          className="font-['SF-Pro-Text-Regular, sans-serif'] hover:!bg-white hover:!text-[#1C4E9D] !bg-transparent -top-6  lg:-top-8 border border-white rounded-[4px] text-xs absolute right-2 !text-white"
        >
          Download
        </Button>

        <div className="mx-4 lg:mx-8">
          <div className="flex gap-2 items-center">
            <h1 className="text-xl text-white font-segoe-ui">
              Metric Overview
            </h1>
            <Tooltip
              title={
                'Projects include System generated wastage BBS, Actual wastage BBS, Wastage without BBS - in the selected quarter'
              }
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="flex w-3.5 h-3.5 cursor-pointer"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>
          {isInitialDataFetch && (
            <p className="font-['SF-Pro-Text-Regular, sans-serif'] text-xs text-white opacity-70">
              Data from the Last Quarter
            </p>
          )}
        </div>

        {/* cards */}
        <div className="justify-center mt-5 mb-8 lg:flex ms-4 lg:ms-8 me-0 lg:me-5">
          <div className="flex flex-col gap-2.5 lg:w-[90%]">
            <div className="grid grid-cols-3 gap-2.5 w-full">
              {COUNTS.slice(0, 3).map((count, i) => {
                return (
                  <MetricsCard
                    id={i + 1}
                    key={count.countColor}
                    data={count}
                    loading={loading}
                    setHovered={setHovered}
                    hovered={hovered}
                  />
                );
              })}
            </div>
            <div
              className={`grid gap-2.5 transition-all duration-300 ease-in-out ${hovered === 4 ? '-ml-10 w-[110%]' : 'w-full'}`}
              style={{
                gridTemplateColumns:
                  hovered === 4 ? '1.3fr 1fr 1fr' : '1fr 1fr 1fr',
              }}
            >
              {COUNTS.slice(3).map((count, i) => (
                <MetricsCard
                  id={i + 4}
                  key={count.countColor}
                  data={count}
                  loading={loading}
                  setHovered={setHovered}
                  hovered={hovered}
                />
              ))}
            </div>
          </div>
        </div>

        <div className="px-2 py-2 ml-3 rounded-xl lg:px-5">
          <div className="flex gap-2 items-center">
            <h1 className="text-xl font-segoe-ui text-[#1C4E9D]">Data</h1>
            <Tooltip
              title={'Data for projects with complete wastage information'}
              overlayInnerStyle={{ fontSize: '10px' }}
            >
              <img
                className="flex w-3.5 h-3.5 cursor-pointer"
                src={dashboardCircle}
                alt="Info Icon"
              />
            </Tooltip>
          </div>

          <WastageProjectInfo
            loading={loading}
            dataSource={leaderShipManagerTableData?.project_list}
          />
        </div>
      </div>
      <div className="absolute top-0 right-6 md:w-[30%] w-full lg:w-[20%]">
        <AdvanceFilter
          loadingData={loading}
          resetFilter={getAllInitialData}
          applyFilter={handleApplyFilter}
          filterForm={
            <ManagerDashboardFilterSelectors
              financialYearsLoading={financialYearsLoading}
              selectedFinancialYear={selectedFinancialYear}
              handleSearch={handleSearch}
              getFinancialYears={getFinancialYears}
              financialYearsData={financialYearsData}
              handleChange={handleChange}
              setSelectedFinancialYear={setSelectedFinancialYear}
              quarterListLoading={quarterListLoading}
              selectedQuarters={selectedQuarters}
              quarterListData={quarterListData}
              setSelectedQuarters={setSelectedQuarters}
              projectListLoading={projectListLoadingManagerDashboard}
              projectListData={projectListDataManagerDashboard}
              projectListLoadingWithoutQuarterly={
                projectListLoadingWithoutQuarterlyManagerDashboard
              }
              projectListDataWithoutQuarterly={
                projectListDataWithoutQuarterlyManagerDashboard
              }
              selectedProjectsCode={selectedProjectsCode}
              setSelectedProjectsCode={setSelectedProjectsCode}
              selectedProjectsName={selectedProjectsName}
              setSelectedProjectsName={setSelectedProjectsName}
              selectedProjectsCodeWithoutQuarterly={
                selectedProjectsCodeWithoutQuarterly
              }
              setSelectedProjectsCodeWithoutQuarterly={
                setSelectedProjectsCodeWithoutQuarterly
              }
              loadProjectNames={loadProjectNames}
              getProjectList={getProjectListManagerDashboard}
              getProjectListWithoutQuarterly={
                getProjectListWithoutQuarterlyManagerDashboard
              }
            />
          }
        />
      </div>
    </div>
  );
};

export default LeaderShipDashboard;
